import { store } from './store.js';
export function AddVariationToCart(props){
	const variations = { ...props };
	return{
		store,
		data: {
			variations,
			currentVariationKey: Object.keys(variations)[0],
			quantity: 1,
			_nonce: wpData.nonce,
			action: 'add_to_cart',
		},
		SubmitData(){
			store.showRotateLogo = true;
			let data = {
				...this.data.variations[this.data.currentVariationKey],
				quantity: this.data.quantity,
				_nonce: this.data._nonce,
				action: this.data.action,
			}
			store.SendAjaxRequest(data)
				.then(response => {
					if (!response.success) throw new Error(response);
					store.cart = response.data.cart;
					this.data.quantity = 1;
					window.dataLayer = window.dataLayer || [];
					window.dataLayer.push({
						'event': 'addToCart',
						'message': response.data.message,
						'data': response.data,
						'ecommerce': {
							'currency': response.data.currency,
							'value': Number(response.data.product.price) * Number(response.data.product.count),
							'items': [
								{
									'item_id': response.data.product.id,        // обязательное поле для GA4
									'item_name': response.data.product.name,    // название товара
									'price': Number(response.data.product.price),
									'quantity': Number(response.data.product.count)
								}
							]
						}
					});
				})
				.catch(console.error)
				.finally(() => store.showRotateLogo = false);
		},
	}
}